/* eslint-disable @typescript-eslint/no-explicit-any */
export enum HttpMethod {
  GET,
  POST,
}

export interface Result {
  succeeded(): boolean;
  authorized(): boolean;
  response: any;
}

export class Success implements Result {
  constructor(readonly response: any) {}

  public succeeded(): boolean {
    return true;
  }

  public authorized(): boolean {
    return true;
  }
}

export class Failure implements Result {
  constructor(readonly response: any, readonly isAuthorized: boolean) {}

  succeeded(): boolean {
    return false;
  }

  authorized(): boolean {
    return this.isAuthorized;
  }
}

export interface HttpClient {
  get(url: string, token: string | undefined, query?: any): Promise<Result>;
  post(url: string, token: string | undefined, query?: any): Promise<Result>;
}
